import React from 'react';
import{MonthConvert,MonthConvert_year} from './utility'
const trimstre = {"first" : 'الثلث الأول',
                     'second':'الثلث الثاني',
                     'third':'الثلث الثالث'}
const PeriodlenghSelect = ({handleDateChange}) => {
  const options = [
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10' },
  ];
  const handleSelectChange = (event)=>{
    handleDateChange(event.target.value);
  }
  return (
    <div>
      <select id="PeriodLenth" onChange={handleSelectChange} className='form-control'>
        {options.map((option) => (
          <option key={option.value} value={option.value} >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
const CyrcleLengthcomponet = ({handleDateChange}) => {
    const options = [
      { value: 22, label: '22' },
      { value: 23, label: '23' },
      { value: 24, label: '24' },
      { value: 25, label: '25' },
      { value: 26, label: '26' },
      { value: 27, label: '27' },
      { value: 28, label: '28' },
      { value: 29, label: '29' },
      { value: 30, label: '30' },
      { value: 31, label: '31' },
      { value: 32, label: '32' },
      { value: 33, label: '33' },
      { value: 34, label: '34' },
      { value: 35, label: '35' },
      { value: 36, label: '36' },
      { value: 37, label: '37' },
      { value: 38, label: '38' },
      { value: 39, label: '39' },
      { value: 40, label: '40' },
      { value: 41, label: '41' },
      { value: 42, label: '42' },
      { value: 43, label: '43' },
      { value: 44, label: '44' },
    ];
    const handleSelectChange = (event)=>{
      handleDateChange(event.target.value);
    }
    return (
      <div>
        <select id="CycleLength" onChange={handleSelectChange} className='form-control' style={{ width: '55px' }} defaultValue={28}>
          {options.map((option) => (
            <option key={option.value} value={option.value} >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  };
  const WeekSelectcomponet = ({handleDateChange}) => {
    const options = [
      { value: 1, label: '1' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5' },
      { value: 6, label: '6' },
      { value: 7, label: '7' },
      { value: 8, label: '8' },
      { value: 9, label: '9' },
      { value: 10, label: '10' },
      { value: 11, label: '11' },
      { value: 12, label: '12' },
      { value: 13, label: '13' },
      { value: 14, label: '14' },
      { value: 15, label: '15' },
      { value: 16, label: '16' },
      { value: 17, label: '17' },
      { value: 18, label: '18' },
      { value: 19, label: '19' },
      { value: 20, label: '20' },
      { value: 21, label: '21' },
      { value: 22, label: '22' },
      { value: 23, label: '23' },
      { value: 24, label: '24' },
      { value: 25, label: '25' },
      { value: 26, label: '26' },
      { value: 27, label: '27' },
      { value: 28, label: '28' },
      { value: 29, label: '29' },
      { value: 30, label: '30' },
      { value: 31, label: '31' },
      { value: 32, label: '32' },
      { value: 33, label: '33' },
      { value: 34, label: '34' },
      { value: 35, label: '35' },
      { value: 36, label: '36' },
      { value: 37, label: '37' },
      { value: 38, label: '38' },
      { value: 39, label: '39' },
      { value: 40, label: '40' },
    ];
    const handleSelectChange = (event)=>{
      handleDateChange(event.target.value);
    }
    return (
      <div>
        <select id="Week" className='form-control' onChange={handleSelectChange}>
          {options.map((option) => (
            <option key={option.value} value={option.value} >
              {option.label}
            </option>
          ))}
        </select>
      </div>
    );
  };
const DueDateTable = (result) => {
    return(
      <table >
      <thead>
        <tr>
          <th >الحالة</th>
          <th > النتائج</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td> تاريخ الولادة المُقدر</td>
          <td>{result.moneyAmout} </td>
        </tr>
        <tr >
          <td>أنتي في</td>
          <td>{result.currentWeek} ({result.numberOfWeeks} أسابيع و{result.remainingDays} أيام أو {result.months} شهر و{result.daysMonth} يومًا) من الحمل. </td>
        </tr>
      </tbody>
    </table>
  )
}
const PregnancyConceptionTable = (Response) => {
  if(Response.Response === null ){
    return ( <div>
    </div>)
  }
  else{
  let response = Response.Response[0];
    return(
      <div>
        <p>
        تواريخ الإخصاب الأكثر احتمالًا:
<b> {response.Most_probable_ConceptionWindowStart}</b> - <b>{response.Most_probable_ConceptionWindowEnd}</b></p>
     <br/><p>
    تواريخ العلاقة الجنسية الأكثر احتمالًا التي أدت إلى الحمل :
    <b> {response.Most_probable_DatesSexual_IntercourseStart}</b> - <b>{response.Most_probable_DatesSexual_IntercourseEnd}</b>
     <br/>
     </p><p>
     تواريخ الإخصاب الممكنة:
    <b> {response.Possible_ConceptionWindowStart}</b> - <b>{response.Possible_ConceptionWindowEnd}</b>
     <br/></p>
     <p>
     تواريخ العلاقة الجنسية الممكنة التي أدت إلى الحمل:
         <b> {response.Possible_DatesSexual_IntercourseStart}</b> - <b>{response.Possible_DatesSexual_IntercourseEnd}</b>
     <br/></p>
    </div>
  )
    }
}
const WeightGainPregnancyTable = (Response,CurrentWeight) => {
  if(Response.Response === null ){
    return ( <div>
    </div>)
  }
  else{
  let response = Response.Response;
  var range = ""
  var bmi =''
  if(response.Weightclassification ==='higher'){range = "وزنك الحالي أعلى من النطاق الموصى به."}
  if(response.Weightclassification ==='lower'){range = "وزنك الحالي أقل من النطاق الموصى به."}
  if(response.Weightclassification ==='normal'){range = "وزنك الحالي في النطاق الموصى به."}
  if(response.BMIresult.BMIclassification ==='Underweight'){bmi ='وزن غير كافٍ'}
  if(response.BMIresult.BMIclassification ==='Normal weight'){bmi ='وزن طبيعي' }
  if(response.BMIresult.BMIclassification ==='Overweight'){bmi ='ماقبل السمنة' }
  if(response.BMIresult.BMIclassification ==='Obese'){bmi ='السمنة' }
    return(
      <div>
        <p>
النطاق الموصى به للوزن في الأسبوع رقم {response.Week} :
<b>{response.Recommended.Max}</b> - <b>{response.Recommended.Min}</b>
<br/>
{range}</p>
    <br/>
           <p>
           النطاق الموصى به للوزن عند الولادة (الأسبوع الـ40):
<b>{response.RecommendedWeightDelivering.Max}</b> - <b>{response.RecommendedWeightDelivering.Min}</b>
</p>
    <br/>
           <p>
           مؤشر كتلة الجسم (BMI): &nbsp;
           <b>{response.BMIresult.BMI}</b> كغ/م2&nbsp;
({bmi})
</p>
    </div>
  )
    }
}
const PregnancyCalculatorTable = (Response) => {
   const trimstre = {"first" : 'الثلث الأول',
                     'second':'الثلث الثاني',
                     'third':'الثلث الثالث'}
  if(Response.Response === null ){
    return ( <div>
    </div>)
  }
  else{
    let response = Response.Response[0];
    return(
      <div>
       <p>
     أنت في الأسبوع رقم {response.CurrentWeek} ({response.NumberOfWeeks} أسابيع و{response.remainingDays} أيام أو {response.Months} شهر و{response.DaysMonth} يومًا) من الحمل.
     </p>
     <p>
     تاريخ الولادة المُقدر هو:&nbsp;
     <b>{response.DueDate}</b>
     </p>
     <p>
     من المرجح أن يكون الحمل قد حدث في {response.conceived}
     </p>
     <p>
      {trimstre[response.Trimstre]}  من فترة الحمل، وقد أكملت {response.Percentage}% من الفترة الكلية للحمل</p>
    </div>
  )
    }
}
export  {PeriodlenghSelect,CyrcleLengthcomponet,DueDateTable,PregnancyConceptionTable,WeekSelectcomponet,WeightGainPregnancyTable,PregnancyCalculatorTable};
